import openSocket from "socket.io-client";
import { getBackendUrl } from "../config";

let socket = null;
let proxy = null;

function makeProxy(sock) {
    return new Proxy(sock, {
        get(target, prop) {
            if (prop === "disconnect") return () => {};
            const val = target[prop];
            return typeof val === "function" ? val.bind(target) : val;
        },
    });
}

function connectToSocket() {
    if (socket && socket.connected) return proxy;

    const raw = localStorage.getItem("token");
    const token = raw ? JSON.parse(raw) : null;

    if (socket) {
        socket.auth = { token };
        socket.connect();
        return proxy;
    }

    socket = openSocket(getBackendUrl(), {
      transports: ["websocket", "polling"],
      auth: { token },
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 10000,
      timeout: 20000,
    });

    proxy = makeProxy(socket);
    return proxy;
}

export function disconnectSocket() {
    if (socket) {
        socket.disconnect();
        socket = null;
        proxy = null;
    }
}

export default connectToSocket;
